import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Merges class names.
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

/**
 * React renders the component again when it notices changes to the state.
 * However, React only does a shallow comparison. It only compares references.
 * This works great for primitives. But it's a pain in the ass for complex state objects.
 * When a field of an object is updated, the reference remains the same. So, React does not see the change.
 * Which means that it will not rerender.
 * We fix that here by spreading the state in an empty object, effectively copying it.
 */
export function makeStateObservableToReact<TState>(state: TState) {
    return { ...state }
}